import { InputHTMLAttributes, ReactNode } from "react";
import styles from "./Toggle.module.scss";

interface ToggleProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string | ReactNode;
  hideLabel?: boolean;
  onChange?: (newValue: boolean) => void;
  stopPropagation?: boolean;
  checked?: boolean;
  title?: string;
  dark?: boolean;
  yellow?: boolean;
  red?: boolean;
  className?: string;
  disabled?: boolean;
}

export function Toggle({
  label,
  hideLabel,
  onChange,
  stopPropagation,
  checked,
  title,
  dark,
  yellow,
  red,
  className,
  disabled,
  id,
  ...rest
}: ToggleProps) {
  return (
    <div className={styles.toggleRow} {...rest}>
      <div className={styles.toggleContainer}>
        <div
          className={`${className ? className : ""} 
          ${styles.toggle} 
          ${dark ? styles.dark : ""}
          ${yellow ? styles.yellow : ""}
          ${red ? styles.red : ""}
          ${disabled ? styles.disabled : ""}
          `}
        >
          <input
            id={id}
            disabled={disabled}
            className={styles.checkBox}
            checked={checked}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (stopPropagation) e.stopPropagation();
              onChange?.(e.target.checked);
            }}
            type="checkbox"
          />
          <span className={styles.roundToggle}></span>
        </div>
      </div>
      {!!label && (
        <label
          htmlFor={`${title}_CHECKBOX`}
          className={hideLabel || title ? "sr-only" : ""}
        >
          {label}
        </label>
      )}
      {!!title && <p>{title}</p>}
    </div>
  );
}
